import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import styles from './Modal.module.scss';
import CloseIcon from '../../../assets/icons/close.svg';

interface ModalProps {
  isOpen: boolean;
  onClose?: () => void;
  title?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  large?: boolean;
  hideCloseButton?: boolean;
  className?: string;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  large = false,
  hideCloseButton = false,
  className,
}) => {
  const modalRoot = document.getElementById('modal');

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('overflowHidden');
      window.scrollTo(0, 0);
    }

    return () => {
      document.body.classList.remove('overflowHidden');
    };
  }, [isOpen]);

  if (!isOpen || !modalRoot) return null;

  return ReactDOM.createPortal(
    <div className={styles.overlay} onClick={onClose}>
      <div
        className={classNames(styles.modal, { [styles.large]: large }, className)}
        onClick={(e) => e.stopPropagation()}
      >
        {(title || !hideCloseButton) && (
          <div className={styles.header}>
            {title && <h2 className={styles.title}>{title}</h2>}
            {!hideCloseButton && onClose && (
              <button className={styles.closeButton} onClick={onClose}>
                <img src={CloseIcon} alt="Close" />
              </button>
            )}
          </div>
        )}
        <div className={styles.body}>{children}</div>
        {footer && <div className={styles.footer}>{footer}</div>}
      </div>
    </div>,
    modalRoot
  );
};

export default Modal;
